import { render, staticRenderFns } from "./PermissionRelationModal.vue?vue&type=template&id=1f354ff2&"
import script from "./PermissionRelationModal.vue?vue&type=script&lang=js&"
export * from "./PermissionRelationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports